(function ($) {
    $(document).on("change", "#modalcall input[type=radio]", function (e) {
        e.preventDefault();

        let parent = $(this).parents("p");
        parent.parents(".type-service").find("p").removeClass("active");
        parent.addClass("active");
    });

    $(document).on("submit", "#modalcall form", function (e) {
        e.preventDefault();

        let $form = $(this);
        let $div = $form.parents(".modal-content");
        let privacy = $('#Form_ClickToCall_privacy').is(":checked");
        let telNumber = $form.find("#Form_ClickToCall_phone").val();
        let typeService = 1;
        if ($form.find("#Form_ClickToCall_requestType_help").prop("type") === "radio") {
            typeService = $form.find("input[type='radio']:checked").val();
        } else {
            typeService = $form.find("#Form_ClickToCall_requestType_help").val();
        }

        let testNumber = /^[0-9]{10}$/;
        if (testNumber.test(telNumber)) {
            if (privacy) {
                var $inputs = $form.find("input, select, button, textarea");
                var requestType = $('#modalcall form input[name="requestType"]:checked').val();
                var phone = $('#modalcall form input[name="phone"]').val();
                var captcha = grecaptcha.getResponse()
                //var serializedData = $('#modalcall form input[type="radio"], #modalcall form input[type="text"]').serialize()

                var spinner = $div.find('#spinner');
                var actionButtons = $div.find('#Form_ClickToCall_action_submitCall');
                var callRespOK = $div.find('#callRespOK');
                var callRespKO = $div.find('#callRespKO');
                $div.find('#callInfo').hide();

                spinner.show();
                actionButtons.hide();
                callRespOK.hide();
                callRespKO.hide();

                $inputs.prop("disabled", true);

                request = $.ajax({
                    url: $('#Form_ClickToCall').attr('action'),
                    type: "post",
                    data: {
                        requestType: requestType,
                        phone: phone,
                        captcha: captcha,
                        action_submitCall: $('#Form_ClickToCall #Form_ClickToCall_action_submitCall').val(),
                        'g-recaptcha-response': $('#Form_ClickToCall #g-recaptcha-response').val()
                    },
                    // g-recaptcha-response: grecaptcha.getResponse(),
                    success: function (data) {
                        spinner.hide();
                        actionButtons.show();
                        // alert('Load was performed.');
                    },
                    error: function () {
                        spinner.hide();
                        actionButtons.show();
                        $inputs.prop("disabled", false);
                        alert("error occurred.");
                    },
                    complete: function () {
                        spinner.hide();
                        actionButtons.show();
                        grecaptcha.reset();
                    }
                });

                request.done(function (response, textStatus, jqXHR) {
                    response = jQuery.parseJSON(response);
                    if (response.status == 'success') {
                        callRespOK.show();
                        callRespKO.hide();
                        $div.find('#textOK').html(response['message']);
                    } else {
                        callRespKO.show();
                        callRespOK.hide();
                        $div.find('#textKO').html(response['message']);
                    }

                    // Log a message to the console
                    //console.log("Request done!", response);
                });

                request.fail(function (jqXHR, textStatus, errorThrown) {
                    response = jQuery.parseJSON(errorThrown);
                    $div.find('#callStep1').hide();
                    callRespKO.show();
                    callRespOK.hide();
                    $div.find('#textKO').html(errorThrown['message']);
                    // Log the error to the console
                    console.error(
                        "The following error occurred: " +
                        textStatus, errorThrown
                    );
                });

                request.always(function () {
                    spinner.hide();
                    $div.find('#callStep1').hide();
                    actionButtons.hide();
                    // Reenable the inputs
                    $inputs.prop("disabled", false);
                });
            } else {
                alert("Please confirm you read the privacy");
            }
        } else {
            alert("Please write a valid phone number");
        }
    });

    // Auto open on idle
    let originalTitle = document.title;
    let flashingTitle = '(!) ' + document.title;
    let titleFlashingInterval;

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    function automaticIdlePopupOpen() {
        if (window.location.pathname != '/' && window.location.pathname != '') {
            return;
        }
        if (window.sessionStorage.getItem('click2callautoopen') == 1) {
            return;
        }

        let existingModal = M.Modal.getInstance(document.getElementById('modalcall'));
        if (existingModal.isOpen) {
            return;
        }

        M.Modal.init(document.getElementById('modalcall'), {
            'onCloseEnd': function () {
                window.clearInterval(titleFlashingInterval);
                document.title = originalTitle;
            }
        });
        let modal = M.Modal.getInstance(document.getElementById('modalcall'));
        modal.open();

        window.sessionStorage.setItem("click2callautoopen", "1")

        titleFlashingInterval = window.setInterval(function () {
            document.title = (document.title == originalTitle ? flashingTitle : originalTitle);
        }, 1 * 1000)
    }

    function setPopupInterval() {
        return window.setTimeout(automaticIdlePopupOpen, 60 * 1000);
    }

    let click2CallPopupOpenInterval = setPopupInterval();

    let resetClick2CallIntervalTimer = debounce(function () {
        window.clearInterval(click2CallPopupOpenInterval);
        click2CallPopupOpenInterval = setPopupInterval();
    }, 250)

    $(window).scroll(resetClick2CallIntervalTimer);
    $(window).click(resetClick2CallIntervalTimer);
    $(window).focus(resetClick2CallIntervalTimer);
    $(window).mousemove(resetClick2CallIntervalTimer);
    $(document).keydown(resetClick2CallIntervalTimer);
    $(document).mousedown(resetClick2CallIntervalTimer);
    $(document).mousedown(resetClick2CallIntervalTimer);


    // let currentYear = new Date().getUTCFullYear();
    // let currentDate = Math.round((new Date()).getTime() / 1000);
    // let christmasDate = Math.round((new Date(currentYear, 11, 23, 21, 0)).getTime() / 1000);
    // let christmasDate_end = Math.round((new Date(currentYear, 11, 25, 21, 0)).getTime() / 1000);
    // let newyearDate = Math.round((new Date(currentYear, 11, 30, 21, 0)).getTime() / 1000);
    // let newyearDate_end = Math.round((new Date(currentYear, 12, 1, 21, 0)).getTime() / 1000);
    //
    // if (currentDate > christmasDate && currentDate < christmasDate_end) {
    //     $(".claim_default").hide();
    //     $(".claim_notice").html("Nos pondremos en contacto contigo a partir del dia 26/12/2020, <br>recuerda que puedes contactar con nosotros llamando al 642.642.642").show();
    // }
    // if (currentDate > newyearDate && currentDate < newyearDate_end) {
    //     $(".claim_default").hide();
    //     $(".claim_notice").html("Nos pondremos en contacto contigo a partir del dia 02/01/2020, <br>recuerda que puedes contactar con nosotros llamando al 642.642.642").show();
    // }

}(jQuery));
